import {
  Spacer,
  Text,
  TooltipPosition,
  TooltipWrapper,
} from "@zapier/design-system";
import styles from "./StepsList.module.css";
import { Step, ZapMetadataStep } from "@zapier/canvas-state";
import getAppIconUrl from "../../utils/getAppIconUrl";
import useServiceById from "../../hooks/useServiceById";
import cleanUpAppId from "../../utils/cleanUpAppId";
import { ServiceIconWithFallback } from "../../components/ServiceIconWithFallback";

type Props = {
  steps: Step[] | ZapMetadataStep[];
  showNumbering?: boolean;
  isDarkMode?: boolean;
  tooltipPosition?: TooltipPosition;
};

const StepsList = ({
  steps,
  showNumbering = true,
  isDarkMode,
  tooltipPosition = "north",
}: Props) => {
  const getService = useServiceById();

  return (
    <ol className={styles.stepsList}>
      {steps.map((step, i) => {
        const appId = step.app;
        const service = getService(appId);
        const images = service?.images;
        const serviceName = service?.name ?? cleanUpAppId(appId);
        const size = 20;

        return (
          <li
            key={step.id}
            className={`${styles.step} ${isDarkMode ? styles.stepDark : ""}`}
          >
            <TooltipWrapper position={tooltipPosition} content={serviceName}>
              {() => (
                <ServiceIconWithFallback
                  serviceName={serviceName}
                  size={size}
                  src={getAppIconUrl(appId, images, size)}
                />
              )}
            </TooltipWrapper>
            <Spacer width={6} />
            <Text
              type="SmallPrint2"
              color={isDarkMode ? "PrimeWhite" : "GrayWarm9"}
            >
              {getStepTitle(step.title, showNumbering, i)}
            </Text>
          </li>
        );
      })}
    </ol>
  );
};

function getStepTitle(
  title: string | undefined,
  showNumbering: boolean,
  i: number,
) {
  if (showNumbering) {
    // TODO
    // Gulliver doesn't return the titles of the steps, so put in placeholder
    // til we have that figured out.
    return `${i + 1}. ${title || `Step ${i + 1}`}`;
  }
  return `${title || `Step ${i + 1}`}`;
}

export default StepsList;
